import React from 'react';
import ShowAgencyBalanceProperties from "./ShowAgencyBalanceProperties";
import {useStyles} from "./ShowAgencyBalance.style";
import clsx from "clsx";
import ShowPrice from '../ShowPrice/ShowPrice';

const ShowAgencyBalance: React.FC<ShowAgencyBalanceProperties> = ({
                                                      value,
                                                      valueBefore,
                                                      className = '',
                                                      showHeader = true,
                                                  }) => {

    const classes = useStyles();
    const isPositive = value >= 0;

    return (
        <div className={clsx(
            classes.container, 
            className,
            isPositive ? classes.positive_border : classes.negative_border
        )}>
            {showHeader && (
                <div className={classes.header}>Saldo:</div>
            )}
            <ShowPrice value={value}/>
            <div className={classes.label}>
                {isPositive ? 'Fondo' : 'Deuda'}
            </div>
        </div>
    )
}


export default ShowAgencyBalance;